import { Coordinate, Project, VideoFlight } from "@nova/protobuf"
import { dateAsNumber } from "../../util"
import {
    booleanValidator,
    genericCreateLayerValidator,
    UnionToTuple,
    updateLayerValidator,
    demoIdValidators,
} from "../util"
import { createNewLayerFractionalIndex } from "../../util/fractional_indexing"
import { isValidLonLat } from "@nova/calculate-geospatial"

export const createVideoFlightValidator = genericCreateLayerValidator

export const updateVideoFlightValidator = updateLayerValidator(VideoFlight, {
    startingPosition: {
        validators: [
            {
                validator: (coordinate: Coordinate) => isValidLonLat(coordinate),
                error: "Coordinates contain invalid values",
            },
        ],
    },
    visible: { validators: booleanValidator("Must pass boolean value"), nonNull: true },
    demoId: {
        validators: demoIdValidators,
    },
})

export const getDefaultVideoFlightCreateArgs = (project: Project, inParentId?: string) => ({
    visible: true,
    createdAt: dateAsNumber(),
    index: createNewLayerFractionalIndex(project, 0, inParentId),
    startingPosition: undefined,

    // parentId would never got autopopulated
    parentId: undefined,
})

export type CreateVideoFlightArgs = UnionToTuple<keyof typeof createVideoFlightValidator>
export type UpdateVideoFlightArgs = UnionToTuple<keyof typeof updateVideoFlightValidator>
